module.exports = __webpack_public_path__ + "static/img/3.73abc85.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/3.png
// module id = 954
// module chunks = 30